import { Form, Formik } from "formik"
import { DateTime } from "luxon"

// Context
import { UserContext } from "../../context/userContext"

//PrimeReact
import { Button } from "primereact/button"
import { Dialog } from "primereact/dialog"

//Styles
import refStyles from "../../styles/Referrals.module.css"

//Referral components
import RefTextAreaInput from "./RefTextAreaInput"
import { getReferralsParticipantServiceStaffId } from "../../config/microservicesSystemUsers"

//graphQL
import { useMutation } from "@apollo/client"
import { UPDATE_REFERRAL_Block } from "./query"
import { LogError } from "../../helpers/logger"
import { useContext, useState } from "react"

export default function ReferralParticipantNote({
  referral,
  isLoading,
  visible,
  thisNoteSet,
  setThisNoteSet,
}) {
  const { setNotificationError } = useContext(UserContext)

  const [thisNote] = useState(referral)

  const [updateReferral] = useMutation(UPDATE_REFERRAL_Block, {
    variables: {
      referral_status: "",
      $referral_participants_notes: "",
      $date_changed: "",
      $idStamp: "",
    },
  })

  const submitNote = async (values) => {
    try {
      const todayLocal = DateTime.now()
      const todayUtc = todayLocal.toUTC().toISO()
      const serviceUserId = getReferralsParticipantServiceStaffId()
      const referral_update = await updateReferral({
        variables: {
          staff_id: serviceUserId,
          organization_id: values.referral.organization_id,
          referral_status: values.referral.values.referral_status,
          referral_participants_notes:
            values.referral.values.referral_participants_notes,
          date_changed: todayUtc,
          idStamp: values.referral.idStamp,
        },
      })

      if (!!referral_update) {
        setThisNoteSet(values.referral.values.referral_participants_notes)
      } else {
        LogError("Unable to submit incomplete referral note", referral_update)
        setNotificationError("Unable to submit incomplete referral note")
      }
    } catch (error) {
      LogError("Unable to submit incomplete referral note", error)
      setNotificationError("Unable to submit incomplete referral note")
    }
  }

  return (
    <Dialog visible={visible} showHeader={false} style={{ width: "35vw" }}>
      <Formik initialValues={thisNote} enableReinitialize onSubmit={submitNote}>
        {({ handleSubmit, isSubmitting }) => (
          <Form onSubmit={handleSubmit} autoComplete="off">
            <div className={refStyles.ratingModalHeader}>
              <label>Participant feedback</label>
            </div>
            <div className={refStyles.ratingModalFormContainer}>
              <hr className={refStyles.ratingModalHeaderLine} />
              <div style={{ height: "150px", marginBottom: "50px" }}>
                <RefTextAreaInput
                  name="referral.values.referral_participants_notes"
                  label="Why did you not complete this referral?"
                  style={{ width: "100%" }}
                  disabled={thisNoteSet}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                {!thisNoteSet ? (
                  <Button
                    label="Submit"
                    icon={isSubmitting && "pi pi-spin pi-spinner"}
                    type="button"
                    className={`${refStyles.ratingButton}`}
                    onClick={() => {
                      handleSubmit()
                    }}
                    loading={isLoading}
                    disabled={isSubmitting}
                  />
                ) : null}
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Dialog>
  )
}
